import { ALL_BUTTON_POSITION_LIST } from '@/common/manager/position/button-position';
export const config = {
    value: 'closeDialog',
    position: ALL_BUTTON_POSITION_LIST,
    action: (config) => {
        const { buttonConfig, _context } = config;
        if (buttonConfig && _context) {
            const { options = {} } = buttonConfig;
            const { _bindDialog } = options;
            if (_bindDialog) {
                const dialogNode = _context.$(_bindDialog);
                dialogNode?.close?.();
                return new Promise((resolve) => {
                    setTimeout(() => {
                        resolve();
                    }, 400);
                });
            }
        }
    },
};
